import React, { useEffect, useState } from "react";

const MarqueeDisplay = ({ data }) => {
  const [position, setPosition] = useState(800);

  // Calculate the total width needed for the content
  const totalWidth = data.reduce((acc) => acc + 300, 0);

  // Animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setPosition((prevPosition) => {
        // Reset position when it's off the screen to create continuous loop
        if (prevPosition < -totalWidth) {
          return 800;
        }
        return prevPosition - 1;
      });
    }, 15); // Slightly slower speed

    return () => clearInterval(interval);
  }, [totalWidth]);

  // Inline styles to avoid external libraries
  const styles = {
    mainContentText: {
      color: "#aaaaaa",
      fontSize: "24px",
    },
    ticker: {
      position: "fixed", // Changed from 'absolute' to 'fixed'
      bottom: 0,
      left: 0,
      width: "100%",
      height: "48px",
      backgroundColor: "#cc0000",
      overflow: "hidden",
      zIndex: 1000, // Added z-index to ensure it stays on top
    },
    tickerInner: {
      height: "100%",
      display: "flex",
      alignItems: "center",
    },
    tickerContent: {
      display: "flex",
      transform: `translateX(${position}px)`,
    },
    tickerItem: {
      display: "flex",
      alignItems: "center",
      marginLeft: "16px",
      marginRight: "16px",
      color: "white",
      whiteSpace: "nowrap",
    },
    customerName: {
      fontWeight: "bold",
      marginRight: "4px",
    },
    loadingPoint: {
      backgroundColor: "#990000",
      padding: "4px 8px",
      borderRadius: "4px",
      fontSize: "12px",
      marginRight: "4px",
    },
    regNumber: {
      fontFamily: "monospace",
    },
  };

  return (
    <div style={styles.ticker}>
      <div style={styles.tickerInner}>
        <div style={styles.tickerContent}>
          {data.map((item, index) => (
            <div key={index} style={styles.tickerItem}>
              <span style={styles.customerName}>{item.CustomerName}</span>
              <span style={styles.loadingPoint}>{item.LoadingPointName}</span>
              <span style={styles.regNumber}>{item.VregNO}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarqueeDisplay;
